import { createContext, useContext, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  // const [isActive, setIsActive] = useState("unreadMessages");
  const [isActive, setIsActive] = useState("notificationLastLeft");
  const [dashLoader, setDashLoader] = useState(false);


  const [unreadRoom, setUnreadRoom] = useState(null);
  const { conversations, countersdata } = useSelector(state => state.message);

  useEffect(() => {
    const unreadThread = countersdata?.conversations?.filter(v => v?.urreply > 0)?.map(c => c?.conversation_id) ?? [];
    const user = (conversations ?? []).filter(data =>
      unreadThread.includes(data?.conversation_id)
    );
    setUnreadRoom(user);
  }, [countersdata, conversations]);



  const demoTasks = [
    {
      id: 1,
      title: "Test Task Workfreeli Development Including Alt...",
      room: "Luciana (you)",
      assignedTo: "Luciana Caetano",
      dueDate: "Sept 21st, 2024",
      color: "blue",
    },
    {
      id: 2,
      title: "Finalize UI Components",
      room: "Luciana (you)",
      assignedTo: "John Doe",
      dueDate: "Sept 21st, 2024",
      color: "purple",
    },
    {
      id: 3,
      title: "Implement Authentication Flow",
      room: "Luciana (you)",
      assignedTo: "Jane Smith",
      dueDate: "Sept 21st, 2024",
      color: "blue",
    },
    {
      id: 4,
      title: "Code Review Session",
      room: "Luciana (you)",
      assignedTo: "Mike Ross",
      dueDate: "Sept 21st, 2024",
      color: "purple",
    },
    {
      id: 5,
      title: "Bug Fix: Dashboard Crash",
      room: "Luciana (you)",
      assignedTo: "Sara Khan",
      dueDate: "Sept 21st, 2024",
      color: "blue",
    },
  ];
  const favoriteChats = [
    { id: 1, name: "Emily Gregory", unread: 3, type: "single", online: "yes" },
    {
      id: 2,
      name: "Marcus Schlaepfer",
      unread: 3,
      type: "single",
      online: "yes",
    },
    {
      id: 3,
      name: "Navigate Living Team",
      unread: 3,
      type: "team",
      online: "",
    },
    { id: 4, name: "Navigate Group Team", unread: 3, type: "team", online: "" },
    { id: 5, name: "Navigate Living", unread: 3, type: "single", online: "no" },
    {
      id: 6,
      name: "Patria Restaurant",
      unread: 3,
      type: "single",
      online: "yes",
    },
  ];

  const chats = [
    { id: 1, name: "Emily Gregory", unread: 3, type: "single", online: "yes" },
    {
      id: 2,
      name: "Marcus Schlaepfer",
      unread: 3,
      type: "single",
      online: "no",
    },
    {
      id: 3,
      name: "Navigate Living Team",
      unread: 3,
      type: "team",
      online: "",
    },
    { id: 4, name: "Navigate Group Team", unread: 3, type: "team", online: "" },
    {
      id: 5,
      name: "Navigate Living",
      unread: 3,
      type: "single",
      online: "yes",
    },
    {
      id: 6,
      name: "Patria Restaurant",
      unread: 3,
      type: "single",
      online: "yes",
    },
    { id: 7, name: "Sophia Turner", unread: 3, type: "single", online: "yes" },
    { id: 8, name: "Logan Marshall", unread: 3, type: "single", online: "no" },
    { id: 9, name: "Community Help Team", unread: 3, type: "team", online: "" },
    {
      id: 10,
      name: "Event Planning Squad",
      unread: 3,
      type: "team",
      online: "",
    },
    { id: 11, name: "Mason Diaz", unread: 3, type: "single", online: "yes" },
    { id: 12, name: "Olivia Bennett", unread: 3, type: "single", online: "no" },
  ];

  return (
    <DashboardContext.Provider
      value={{
        isActive,
        setIsActive,
        dashLoader,
        setDashLoader,
        demoTasks,
        favoriteChats,
        chats,
        unreadRoom
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => {
  return useContext(DashboardContext);
};
